import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * React Router doesn't reset scroll position on navigation — the browser
 * just keeps whatever offset the previous page had. Depends only on
 * pathname (not the full location) so in-page hash links (e.g. href="#faq")
 * aren't affected, only actual route changes.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
